// apps/scheduler-worker/src/hooks/useProfile.ts
import { useQuery } from '@tanstack/react-query';
import { fetchMyProfile, type ProfileResponse } from '../lib/api';
import { useOnlineStatus } from './useOnlineStatus';

export function useProfile() {
  const isOnline = useOnlineStatus();

  return useQuery<ProfileResponse['data'] | null>({
    queryKey: ['my-profile'],
    queryFn: async () => {
      if (!isOnline) return null;
      const response = await fetchMyProfile();
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
